module.exports = __webpack_public_path__ + "static/media/Vlees.404a6af1.svg";